import * as R from 'ramda';
import { Alert, Button, Spinner, Table, OverlayTrigger } from 'react-bootstrap';
import { IElasticResult, ISearchRecord } from '../../types/search';
import React, { useState, useRef, useEffect } from 'react';
// import mapImage from '../../assets/search-map.png';
import { CSVLink } from 'react-csv';
import { FileText } from 'react-feather';
import { search, storage } from '../../services/firebase';
import { IAuthContext } from '../../context/auth/auth-context';
import SearchPagination from './SearchPagination';
import SearchResultMap from './map';
import { TIERS } from '../../types/tiers';
import mediaQuery from '../../util/media-query';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import withAuthContext from '../../context/auth/AuthConsumer';
import { CUSTOM_SEARCH_TYPE } from '../../types/search-type';
import { useHistory } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { useSelector } from 'react-redux';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import ReactGA from 'react-ga4';

interface ISearchResultContainer {
  result: IElasticResult<ISearchRecord> | null;
  docSearchEPNResult: any | null;
  error?: any;
  quickSerch: string;
  setQuickSerch: any;
  currentQueryText: any;
  isLoading: boolean;
  isQuickFilter: boolean;
  setQuickFilter: any;
  doTextSearch: any;
  sourceType: CUSTOM_SEARCH_TYPE;
  applyFilterToQuery: any;
  filter: any;
}

const TableContainer = styled.div`
  margin: 0 1.4em 0;
  padding: 0.75em 1.5em;
  background: rgba(248, 250, 252, 0.95);
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(2, 6, 23, 0.18);
  color: #0f172a;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif;

  .table-container {
    overflow: auto;
    max-height: 82vh;
    min-height: 460px;
  }

  table {
    color: inherit;
  }

  thead th {
    color: #0f172a;
    background: #e2e8f0;
  }

  tbody td {
    color: #111827;
  }

  a {
    color: #005fbc;
  }

  .alert {
    background: #fff7dd;
    border-color: #facc15;
    color: #1f2937;
  }
  /* Prevent sticky header bleed by avoiding collapsed borders */
  #searchResult {
    border-collapse: separate;
    border-spacing: 0;
  }
  ${mediaQuery.phone`
    margin: 0 1em;
    padding: 1em 0;
 `}
  ${mediaQuery.tablet`
    margin: 0 1em;
    display: grid;
  `}

  .back-btn {
    position: fixed;
    bottom: 3%;
    min-width: 15%;
    border-radius: 50px;
    margin: 0 42.5%;
    background-color: #5dc5c4 !important;
  }
`;

const NotFoundContainer = styled.div`
  justify-content: center;
  display: flex;
  flex: 1;
`;

const ContentTD = styled.td<{ $rowShade?: 'odd' | 'even' }>`
  ${mediaQuery.phone`
    font-size: 13px;
  `}
  && {
    padding: 0.5em 0.75em;
    font-size: 12px;
    line-height: 1.45;
    color: #111827;
    border-color: rgba(148, 163, 184, 0.35) !important;
    background: ${({ $rowShade }) => ($rowShade === 'odd' ? '#f1f5f9' : '#ffffff')};
  }
  em,
  strong,
  b {
    font-style: normal;
    font-weight: 650;
    color: #111827;
    background: rgba(134, 239, 172, 0.35);
    border-radius: 4px;
    padding: 0 3px;
  }
`;

const RecordTR = styled.tr<{ $rowShade?: 'odd' | 'even' }>`
  && {
    background: transparent;
    td {
      background: ${({ $rowShade }) => ($rowShade === 'odd' ? '#f1f5f9' : '#ffffff')};
    }
  }
`;

const RecordTD = styled.td<{ $rowShade?: 'odd' | 'even' }>`
  ${mediaQuery.phone`
    font-size: 13px;
  `}
  && {
    padding: 3px 0.7em;
    vertical-align: middle;
    font-size: 12px;
    line-height: 1.3;
    color: #111827;
    border-color: rgba(148, 163, 184, 0.35) !important;
    background: ${({ $rowShade }) => ($rowShade === 'odd' ? '#f1f5f9' : '#ffffff')};
  }
`;
const DownloadTD = styled<any>(RecordTD)`
  display: flex;
  justify-content: center;
  cursor: pointer;
  button {
    width: 65px;
    height: 32px;
    padding: 2px 5px;
    font-size: 14px;
    svg {
      width: 20px;
      margin-right: 5px;
    }
    .spinner-border {
      width: 20px;
      height: 20px;
    }
  }
`;
const STR = styled.tr<{ isAuth: boolean }>`
  position: sticky;
  top: 0;
  z-index: 3;
  background: #e2e8f0;
  color: #0f172a;
  text-align: center;
  height: 44px;
  & th {
    vertical-align: top !important;
    border-color: rgba(148, 163, 184, 0.4) !important;
    font-weight: 700;
    letter-spacing: 0.02em;
    background: #e2e8f0;
    font-size: 12px;
    ${mediaQuery.phone`
      font-size: 13px;
    `}
  }
`;
const Download = styled.button`
  background-color: #34d399;
  border: none;
  border-radius: 999px;
  color: #070a0d;
  cursor: pointer;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 7px 24px;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.22);
  transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;

  &:hover:not(:disabled) {
    background-color: #40e48c;
    transform: translateY(-1px);
    box-shadow: 0 14px 30px rgba(0, 0, 0, 0.28);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
    transform: none;
    box-shadow: none;
  }
`;

const getFileTypeText = (type: string) => {
  switch (type) {
    case 'pdf':
      return 'PDF';
    default:
      break;
  }
  return '';
};

const headers = [
  { label: 'Relevance Score', key: 'relevance_score' },
  { label: 'Entity Name', key: 'entity_name' },
  { label: 'Type', key: 'type' },
  { label: 'Release Date', key: 'date' },
  { label: 'Category', key: 'category' },
  { label: 'Regulatory ID', key: 'regulatory_id' },
  { label: 'File', key: 'file_url' },
  { label: 'Text Snippet', key: 'text_snippet' },
];

/**
 * check if the file needs to be downloaded from storage bucket
 * or rely on the file url, directly.
 */
const doStorageDownload = R.contains(R.__, ['tceq_novell']);

const getStorageRef = R.cond<string, ReturnType<typeof getStorage> | null>([
  [
    R.equals('tceq_novell'),
    R.always(getStorage(undefined, `gs://${process.env.REACT_APP_STORAGE_BUCKET_NOVELL}`))
  ],
  [R.T, R.always(null)],
]);

const SearchResultContainer: React.FC<ISearchResultContainer & { context: IAuthContext }> = (props) => {
  const records = React.useMemo(() => props.result ? props.result.records : [], [props.result]);
  const history = useHistory();
  const { applyFilterToQuery, quickSerch, currentQueryText, filter, sourceType } = props;
  const csvInstance: any = useRef();
  const context = props.context;
  const [showWarning, setShowWarning] = useState(!context.isAuthenticated);
  const [downloadTriggers, setDownloadTriggers] = useState<string[]>([]);
  const isDownloading = (contentId: string) => R.contains(contentId, downloadTriggers);
  const [showFreeTierWarning, setShowFreeTierWarning] = useState(context.isTier(TIERS.FREE));
  const [csvData, setCSVData] = useState<any>([]);
  const [isLoader, setLoader] = useState<boolean>(false);
  const [isAllLoader, setAllLoader] = useState<boolean>(false);
  const [showMap, setShowMap] = useState<boolean>(false);
  const [mapSpinner, setMapSpinner] = useState<boolean>(false);
  const store: any = useSelector<any>((state): any => state);
  const activeJurisdiction = useSelector<any, string>((s) => s.jurisdiction.activeId);
  const isBackButton = !!store.globalFlags.previousPage && store.globalFlags.previousPage === 'myenviroaiToAgency';
  // Count unique facilities (markers) with valid locations
  const facilitiesCount = React.useMemo(() => {
    const isValidLatLong = (lat: number, lng: number) => lat !== 0 && lng !== 0;
    const uniqueFacilities = R.compose<any, any, any, any>(
      R.uniqBy(R.prop('entityNumber')),
      R.filter((record: any) =>
        !!record &&
        record.location &&
        typeof record.location.lat !== 'undefined' &&
        typeof record.location.lon !== 'undefined' &&
        isValidLatLong(record.location.lat, record.location.lon)
      ),
      R.filter((record: any) => !!record && !!record.entityNumber)
    )(records || []);
    return uniqueFacilities.length || 0;
  }, [records]);

  const isFirstPage = (props.result && props.result.from === 0) || false;
  const isLastPage = React.useMemo(() => {
    const result = props.result;
    if (!result || typeof result.from !== 'number' || typeof result.size !== 'number') {
      return true;
    }
    const pageCount = result.records?.length ?? 0;
    if (pageCount === 0 || pageCount < result.size) {
      return true;
    }
    const totalVal = result.total?.value;
    if (typeof totalVal === 'number') {
      return result.from + pageCount >= totalVal;
    }
    return false;
  }, [props.result]);

  const handlePreviousClick = () => {
    if (!props.result || isFirstPage || props.isLoading) {
      return;
    }
    props.doTextSearch(
      currentQueryText,
      props.result.from - props.result.size,
      sourceType
    );
  };

  const handleNextClick = () => {
    if (!props.result || isLastPage || props.isLoading) {
      return;
    }
    props.doTextSearch(
      currentQueryText,
      props.result.from + props.result.size,
      sourceType
    );
  };

  const csvDataGet = async () => {
    let jsonArray: any = '';
    const from = 0;
    const size = 100;
    setLoader(true);
    await search(
      applyFilterToQuery(
        {
          query: {
            from,
            size,
            text: currentQueryText + (quickSerch ? ' ' + quickSerch : ''),
            source_type: sourceType,
            jurisdiction: activeJurisdiction,
          },
        },
        filter || {},
        CUSTOM_SEARCH_TYPE.DEFAULT
      )
    )
      .then((result) => {
        const data = result.data as IElasticResult<ISearchRecord>;
        if (data.records.length > 0) {
          data.records.map((record) => {
            const dataCSV = [
              {
                relevance_score: record.relevanceScore,
                entity_name: record.entityName,
                type: record.title,
                date: record.releaseDate,
                category: record.seriesName,
                regulatory_id: record.entityNumber,
                file_url: record.fileUrl,
                text_snippet: record.hitContent,
              },
            ];
            if (jsonArray) {
              jsonArray = jsonArray.concat(dataCSV);
            } else {
              jsonArray = dataCSV;
            }
            return true;
          });
          setCSVData(jsonArray);
          // Track CSV download event
          ReactGA.event({
            category: 'Search',
            action: 'Download CSV',
            label: currentQueryText,
            value: jsonArray.length
          });
          csvInstance.current.link.click();
        }
      })
      .finally(() => setLoader(false));
  };

  const downloadAllResults = async () => {
    setAllLoader(true);
    try {
      // Use smaller batch size to avoid timeouts
      const pageSize = 250; // Smaller batch size to avoid timeouts
      const targetSize = 10000;
      let from = 0;
      let allRecords : ISearchRecord[] = [];
      // Fetch data in smaller batches with delay between requests
      while (from < targetSize && allRecords.length < targetSize) {
        // console.log(`Fetching records ${from} to ${from + pageSize}...`);
        try {
          // Add a small delay between requests to prevent rate limiting
          if (from > 0) {
            await new Promise(resolve => setTimeout(resolve, 300));
          }
          const result = await search(
            applyFilterToQuery(
              {
                query: {
                  from,
                  size: pageSize,
                  text: currentQueryText + (quickSerch ? ' ' + quickSerch : ''),
                  source_type: sourceType,
                  jurisdiction: activeJurisdiction,
                },
              },
              filter || {},
              CUSTOM_SEARCH_TYPE.DEFAULT
            )
          );
          if (!result || !result.data) {
            // console.log("No result or data returned");
            break;
          }
          const data = result.data as IElasticResult<ISearchRecord>;
          // Check if we have records before trying to use them
          if (!data.records || data.records.length === 0) {
            // console.log("No more records to fetch");
            break;
          }
          // Add this batch to our collection
          allRecords = [...allRecords, ...data.records];
          // console.log(`Progress: ${allRecords.length}/${targetSize} records`);
          // If we got fewer records than requested, there are no more to fetch
          if (data.records.length < pageSize) {
            // console.log("Received fewer records than requested, ending pagination");
            break;
          }
          // Move to next page
          from += pageSize;
        } catch (batchError) {
          // console.error("Error fetching batch:", batchError);
          // If we encounter an error, try the next batch with a smaller size instead of stopping completely
          from += pageSize;
        }
      }
      // console.log(`Total records fetched: ${allRecords.length}`);
      if (allRecords.length === 0) {
        toast.warn('No results found to download');
        return;
      }
      // Process records for CSV
      const jsonArray = allRecords.map(record => ({
        relevance_score: record.relevanceScore,
        entity_name: record.entityName,
        type: record.title,
        date: record.releaseDate,
        category: record.seriesName,
        regulatory_id: record.entityNumber,
        file_url: record.fileUrl,
        text_snippet: record.hitContent,
      }));
      if (jsonArray.length > 0) {
        setCSVData(jsonArray);
        // Track All Results download event
        ReactGA.event({
          category: 'Search',
          action: 'Download All Results',
          label: currentQueryText,
          value: jsonArray.length
        });
        csvInstance.current.link.click();
      }
    } catch (error) {
      // console.error("Error downloading results:", error);
    } finally {
      setAllLoader(false);
    }
  };
  useEffect(() => {
    if (showMap && mapSpinner) {
      setMapSpinner(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMap]);

  const handleBackButton = (e: any) => {
    // flag use to clear chat data when user visit enviro page not from here
    localStorage.setItem('isBackToEnviroPage', 'true');
    history.replace('myenviroai');
  };

  if (props.result && props.result.records && props.result.records.length === 0) {
    return (
      <TableContainer>
        <NotFoundContainer>
          <h3>No results found.</h3>
        </NotFoundContainer>
        {isBackButton && <Button variant="primary" className="back-btn" size="lg" onClick={handleBackButton}>Back</Button>}
      </TableContainer>
    );
  }
  if (!props.result) {
    return <></>;
  }

  return (
    <div>
      <TableContainer>
        <Alert variant="warning" show={showWarning} onClose={() => setShowWarning(false)} dismissible>
          <Alert.Heading>Get access to better results!</Alert.Heading>
          <p>
            <Alert.Link href="/login">Login</Alert.Link> to your account, to get better search results, including file
            downloads!
          </p>
        </Alert>
        <Alert
          variant="warning"
          show={!showWarning && showFreeTierWarning}
          onClose={() => setShowFreeTierWarning(false)}
          dismissible
        >
          <Alert.Heading>Get access to better results!</Alert.Heading>
          <p>
            Upgrade your account to{' '}
            <em>
              <b>Basic</b>
            </em>{' '}
            or{' '}
            <em>
              <b>Platinum</b>
            </em>{' '}
            tier, to get better search results, including file downloads!
          </p>
        </Alert>
        <div className="table-container">
          <Table id="searchResult" responsive="md" striped bordered hover>
            <thead>
              <STR isAuth={context.isAuthenticated}>
                <th>Relevance Score</th>
                <th>Entity Name</th>
                <th>Type</th>
                <th>Release Date</th>
                <th>Category</th>
                <th>Regulatory ID</th>
                <th>File</th>
              </STR>
            </thead>
            <tbody>
              {records && records.map((record, i) => {
                const isFileDownloading = isDownloading(record.contentId);
                const rowShade: 'odd' | 'even' = i % 2 === 0 ? 'even' : 'odd';
                return (
                  <React.Fragment key={i}>
                    <RecordTR $rowShade={rowShade}>
                    <RecordTD $rowShade={rowShade}>{`${record.relevanceScore}%`}</RecordTD>
                    <RecordTD $rowShade={rowShade}>{record.entityName}</RecordTD>
                    <RecordTD $rowShade={rowShade}>{record.title}</RecordTD>
                    <RecordTD $rowShade={rowShade}>{record.releaseDate}</RecordTD>
                    <RecordTD $rowShade={rowShade}>{record.seriesName}</RecordTD>
                    <RecordTD $rowShade={rowShade}>{record.entityNumber}</RecordTD>
                    <DownloadTD
                      onClick={() => {
                        if (!context.isAuthenticated) {
                          return toast.warn(
                            <span>
                              Please <Alert.Link href="/login">login</Alert.Link> to download files.
                            </span>,
                            {
                              position: toast.POSITION.BOTTOM_CENTER,
                            }
                          );
                        }
                        if (!context.isLubrizol()) {
                          if (context.isTier(TIERS.FREE)) {
                            return toast.warn(<span>Please upgrade to BASIC or PLATINUM to download files.</span>, {
                              position: toast.POSITION.BOTTOM_CENTER,
                            });
                          }
                        }
                        if (doStorageDownload(record.entitySource)) {
                          const storageRef = getStorageRef(record.entitySource);
                          if (R.isNil(storageRef)) {
                            return toast.error(`Oops, could not find the file.`);
                          }
                          setDownloadTriggers(R.append(record.contentId, downloadTriggers));
                          return getDownloadURL(ref(storage, record.fileName))
                            .then((url) => window.open(url, '_blank', 'noopener,noreferrer'))
                            .catch((err) => toast.error(err.message))
                            .finally(() =>
                              setDownloadTriggers(R.without([record.contentId], downloadTriggers))
                            );
                        }
                        if (!record.fileUrl) {
                          return toast.warn(
                            <span>
                              No associated file was found for the content id <b>{record.contentId}</b>
                            </span>
                          );
                        }
                        if (record.entitySource.includes('tceq')) {
                          const encodedUri = encodeURIComponent(record.fileUrl);
                          const contentFileUrlNew = `${process.env.REACT_APP_CERES_URL}/GetDocs?id=${record.contentId}&u=${encodedUri}`;
                          window.open(contentFileUrlNew, '_blank');
                        } else {
                          window.open(record.fileUrl, '_blank');
                        }
                      }}
                    >
                      <OverlayTrigger
                        overlay={<ReactTooltip place="top" effect="solid" />}
                      >
                        <Button data-tip="Click to download" variant="secondary" disabled={isFileDownloading}>
                          {isFileDownloading && <Spinner variant="light" animation="border" />}
                          {!isFileDownloading && (
                            <>
                              <FileText />
                              <span>{getFileTypeText(record.fileType)}</span>
                            </>
                          )}
                        </Button>
                      </OverlayTrigger>
                    </DownloadTD>
                    </RecordTR>
                  <tr>
                    <ContentTD
                      $rowShade={rowShade}
                      colSpan={7}
                      dangerouslySetInnerHTML={{
                        __html:
                          record.hitContent.length > 0
                            ? record.hitContent
                              // Remove non-ascii chars.
                              .map((str: string) => {
                                /*eslint no-control-regex: 0*/
                                let wordGroup = '';
                                currentQueryText
                                  .trim()
                                  .split(' ')
                                  .map((srcWord: string) => {
                                    return (wordGroup += `<em>${srcWord.replace(/['",-]+/g, '')}</em>|`);
                                  });
                                return props.isQuickFilter && currentQueryText
                                  ? str.replace(/[^\x00-\x7F]/g, '').replace(new RegExp(wordGroup, 'gi'), (word) => {
                                    return word.replace(/<[^>]*>?/gm, '');
                                  })
                                  : str.replace(/[^\x00-\x7F]/g, '');
                              })
                              .join('<br />')
                            : '<h3>No Preview Available</h3>',
                      }}
                    />
                  </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        </div>

        <SearchPagination
          isDisabled={props.isLoading}
          isFirstPage={isFirstPage}
          isLastPage={isLastPage}
          totalRecords={(props.result && props.result.total && props.result.total.value) || 0}
          facilitiesCount={facilitiesCount}
          onPreviousClick={handlePreviousClick}
          onNextClick={handleNextClick}
        />
        <div style={{ display: 'flex', gap: '10px' }}>
          <Download className="btn" onClick={csvDataGet} disabled={isLoader}>
            {isLoader && <Spinner animation="border" variant="light" size="sm" />} Download CSV
          </Download>

          <Download className="btn" onClick={downloadAllResults} disabled={isAllLoader}>
            {isAllLoader && <Spinner animation="border" variant="light" size="sm" />} Download All Results
          </Download>
          {(
            <Download className="btn" onClick={
              () => {
                setMapSpinner(true);
                setShowMap(!showMap);
              }}
            >
              {showMap ? 'Hide Map' : 'Generate Document Location Map'}
            </Download>
          )}
        </div>
        {csvData.length > 0 && (
          <CSVLink
            data={csvData}
            headers={headers}
            filename={`${currentQueryText + (quickSerch ? ' ' + quickSerch : '')}_${isAllLoader ? 'all' : '100'}.csv`}
            style={{ visibility: 'hidden' }}
            ref={csvInstance}
          >
            Download CSV
          </CSVLink>
        )}

        {showMap && (context.isTier(TIERS.SUPER_ADMIN) ||
          ((context.isTier(TIERS.PLATINUM) || context.isTier(TIERS.DAYPASS)) && context.isAuthenticated) ||
          (context.isLubrizol() && context.isAuthenticated)) && (
            <SearchResultMap records={records} docSearchEPNResult={props.docSearchEPNResult} context={context} />
          )}
        {/* {
          !showMap &&
          <div className="card mb-3" style={{ maxWidth: '1200px', margin: '1rem auto' }}>
            <div className="row no-gutters">
              <div className="col-md-5">
                <img style={{ height: '100%' }} src={mapImage} className="card-img-top" alt="search-map" />
              </div>
              <div className="col-md-7">
                <div className="card-body">
                  <h5 className="card-title">Map of Document Locations</h5>
                  <p className="card-text">Click the below button to see all the site locations in the map for your search</p>
                  <p className="card-text"><small className="text-muted">We found matches for your search</small></p>
                  <button className="btn btn-primary" onClick={() => {
                    setMapSpinner(true);
                    setShowMap(true);
                  }}>
                    Click here to expand the Map &nbsp;
                    {mapSpinner && <Spinner variant="light" animation="border" size="sm" />}
                  </button>
                </div>
              </div>
            </div>
          </div>
        } */}
        {isBackButton && <Button variant="primary" className="back-btn" size="lg" onClick={handleBackButton}>Back</Button>}
      </TableContainer>
    </div>
  );
};

export default withAuthContext(SearchResultContainer);
